import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getTheme = async (
  token: string,
  baseUrl: string,
  config?: any
) => {
  try {
    const queryPath = `${baseUrl}/theme`;

    const res = await get(token, queryPath, {}, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
